import { getPlatformUserStatus } from '@/api/user';
import { HelloCertEnum, UserCertEnum } from '@/api/user/types';
import { confirmDialog } from '@/components/dialog';
import { AuthSceneTypeEnum, dialogTipsMap, dialogUbtName } from './types';
import jumpToVerifyCredit from '../verify-credit-controller';
import { VerifySceneEnum } from '../verify-credit-controller/types';

export class PlatformIdentity {
    /** 用来标记是否要走新用户流程 */
    public dispatchNewUserStatus = false;

    public async newUserAuthProgress():Promise<boolean> {
      // 做过Ab实验且有全局状态
      if (this.dispatchNewUserStatus) {
        return this.dispatchNewUserStatus;
      }
      // 获取平台用户状态
      const userStatus = await getPlatformUserStatus();
      const { userCertMode } = userStatus;
      this.dispatchNewUserStatus = userCertMode === UserCertEnum.Platform;
      return userCertMode === UserCertEnum.Platform;
    }

    /** 平台实名用户校验 */
    public async checkUserAuth(sceneType:AuthSceneTypeEnum):Promise<boolean> {
      // 获取平台用户状态
      const userStatus = await getPlatformUserStatus();

      const { userCertMode, helloCertType, needReUpload } = userStatus;
      const ubtName = dialogUbtName.get(sceneType);

      // 弹窗
      const diaTips = dialogTipsMap.get(sceneType);
      const { title = '', content = '', confirmText = '' } = diaTips || {};

      // 标记全局，用于流程中判断是否要走新的用户实名流程
      this.dispatchNewUserStatus = userCertMode === UserCertEnum.Platform;

      // 非平台实名用户
      if (userCertMode === UserCertEnum.Platform
         && helloCertType === HelloCertEnum.NOT_IDENTITY_VERIFICY) {
        if (!diaTips) {
          return new Promise((resolve) => { resolve(true); });
        }

        await confirmDialog.open({
          title,
          content,
          confirmText,
          ubtName: (ubtName && ubtName.otherType) || '',
        });
        return new Promise((resolve, reject) => { reject(); });
      }

      // 用户更新身份证信息
      if (userCertMode === UserCertEnum.Platform
        && needReUpload) {
        // 弹窗
        await confirmDialog.open({
          title: '请更新您的身份证照片',
          content: '您在哈啰更新了实名信息，但未更新照片，请上传对应身份证照片后再继续流程',
          confirmText: '现在上传',
          ubtName: (ubtName && ubtName.needUpdatePhoto) || '',
        });

        jumpToVerifyCredit(VerifySceneEnum.PERSONAL_IDENTITY_MODIFY);

        return new Promise((resolve, reject) => { reject(); });
      }

      return new Promise((resolve) => { resolve(true); });
    }
}

export const platformIdentityManager = new PlatformIdentity();
